var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize.initial",
          value: _vm.handleResize,
          expression: "handleResize",
          modifiers: { initial: true }
        }
      ],
      staticClass: "scrolling-wrapper"
    },
    [
      !_vm.$isMobile
        ? _c(
            "div",
            {
              staticClass: "scroll-arrow left",
              on: {
                mousedown: function() {
                  return _vm.handleArrowClick(-360)
                }
              }
            },
            [
              _c("BaseIcon", {
                attrs: { isCustom: true, icon: "backChevron", size: "3x" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        ref: "scrollingContainerOverlay",
        staticClass: "scrolling-container-overlay"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollingContainer",
          staticClass: "scrolling-container",
          on: { scroll: _vm.handleScroll }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      !_vm.$isMobile
        ? _c(
            "div",
            {
              staticClass: "scroll-arrow right",
              on: {
                mousedown: function() {
                  return _vm.handleArrowClick(360)
                }
              }
            },
            [
              _c("BaseIcon", {
                attrs: { isCustom: true, icon: "backChevron", size: "3x" }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-104b7721", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104b7721","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseScrollingContainer.vue
// module id = null
// module chunks = 